import { V3_API_URL } from 'views/TradingCompetitionV3/config'

// Competition V4 wiring (feature flag). Without NEXT_PUBLIC_COMPETITION_V4_ADDRESS the V4 pages say "not available"
// and every link keeps pointing at V3. The contract is not deployed anywhere yet (2026-10-01).
export const V4_ADDRESS = (process.env.NEXT_PUBLIC_COMPETITION_V4_ADDRESS || '') as `0x${string}` | ''
export const V4_ENABLED = Boolean(V4_ADDRESS)
export const V4_CHAIN_ID = Number(process.env.NEXT_PUBLIC_COMPETITION_V4_CHAIN_ID || 56)
export const V4_API_URL = process.env.NEXT_PUBLIC_COMPETITION_V4_API_URL || `${new URL(V3_API_URL).origin}/api/competitions/v4`
export const CBON = '0x6e64fCF15Be3eB71C3d42AcF44D85bB119b2D98b' as const
export const CREATE_PATH = V4_ENABLED ? '/trading-competition/create' : '/trading-competition-v3/create'
